import React, { useState, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import {
  reloadYardCommodityByActiveBySortKey,
  reloadYardCapabilityByReloadYard,
  userByActiveByLastName,
} from "../../../graphql/queries";

import { Box, Chip, Paper, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  ArrayField,
  Datagrid,
  Loading,
  Show,
  SimpleShowLayout,
  TextField,
  useNotify,
} from "react-admin";

import { ClipboardTextField } from "../../../components/common/CopyToClipboardButton";
import { logError } from "../../../utils/appUtils";
import MonthlyInboundsChart from "../../../managerApp/reports/shipment/MonthlyInboundsChart";
import { formatPhoneNumber } from "../../../utils/utils";

const _ = require("lodash");

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    marginLeft: theme.spacing(0.5),
    marginTop: -theme.spacing(0.5),
  },
  fixedHeightPaper: {
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    padding: theme.spacing(2),
    height: 256,
  },
}));

const Separator = () => <Box pt="1em" />;

export const ReloadYardPeak = ({ record, ...props }) => {
  const classes = useStyles();
  const notify = useNotify();
  const [commodities, setCommodities] = useState([]);
  const [users, setUsers] = useState({});
  const [loading, setLoading] = useState(true);
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      debugger;

      setLoading(true);
      let res = await API.graphql(
        graphqlOperation(reloadYardCommodityByActiveBySortKey, {
          reloadYardId: record.id,
          activeSortKey: { beginsWith: { active: "true" } },
        })
      );
      let data = res.data.reloadYardCommodityByActiveBySortKey.items;
      setCommodities(data);

      res = await API.graphql(
        graphqlOperation(reloadYardCapabilityByReloadYard, {
          reloadYardId: record.id,
          active: { beginsWith: "true" },
        })
      );
      data = res.data.reloadYardCapabilityByReloadYard.items;
      data = _.orderBy(data, ["capability.sortKey"], ["asc"]);

      // list active users and transloads.co admins
      const userQuery = {
        reloadYardId: record.id,
        // retain inactive Admin users
        // activeLastName: { beginsWith: { active: "true" } },
      };
      res = await API.graphql(
        graphqlOperation(userByActiveByLastName, userQuery)
      );
      data = res.data.userByActiveByLastName.items.filter(
        (item) => item.active === "true" || item.email.includes("@transload.co")
      );
      const userRec = { users: data };
      setUsers(userRec);
    } catch (err) {
      logError("reloadYard:ReloadYardPeak:getData", err, notify);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;
  return (
    <Show {...props} title=" " actions={null}>
      <SimpleShowLayout>
        <Paper component="ul" className={classes.root}>
          <Typography variant="caption" display="inline">
            {" "}
            Rail / Interstate:{" "}
          </Typography>
          {record?.railHighway.map((item) => (
            <li key={item}>
              <Chip label={item} className={classes.chip} />
            </li>
          ))}
        </Paper>
        <Separator />
        <Paper component="ul" className={classes.root}>
          <Typography variant="caption" display="inline">
            {" "}
            Commodities:{" "}
          </Typography>
          {commodities?.map((item) => (
            <li key={item.capabilityId}>
              <Chip label={item.commodity.name} className={classes.chip} />
            </li>
          ))}
        </Paper>
        <Separator />

        <Separator />
        <ClipboardTextField
          source="id"
          label="reloadYardId"
          classes={classes}
        />
        <Paper component="ul" className={classes.root}>
          <ArrayField source="users" record={users}>
            {isXSmall ? (
              <Datagrid>
                <TextField source="fullName" />
                <TextField source="email" />
              </Datagrid>
            ) : (
              <Datagrid>
                <TextField source="fullName" />
                <ClipboardTextField
                  source="email"
                  label="Email"
                  classes={classes}
                  notify={notify}
                />
                <ClipboardTextField
                  source="phone"
                  label="Phone"
                  classes={classes}
                  notify={notify}
                  format={(val) => val && formatPhoneNumber(val)}
                />
                <TextField source="type" />
                <TextField source="cognitoId" />
              </Datagrid>
            )}
          </ArrayField>
        </Paper>
        <Separator />
        <Paper className={classes.fixedHeightPaper}>
          <MonthlyInboundsChart reloadYardId={record?.id} />
        </Paper>
      </SimpleShowLayout>
    </Show>
  );
};
